export default "__VITE_ASSET__0fbac61d__"